module.exports = __webpack_public_path__ + "static/media/Friendly.ac8be4f1.svg";